import React from "react";
import './footer.css'

const Footer = () => {
	return (
		<footer className='footer'>
			<div className='footer__container container'>
				<h1 className='footer__title'>Vamsi</h1>

				<ul className='footer__list'>
					<li>
						<a href='#about' className='footer__link'>
							About
						</a>
					</li>

					<li>
						<a href='#portfolio' className='footer__link'>
							Projects
						</a>
					</li>
				</ul>

				<div className='footer__social'>
					<a
						href='https://www.linkedin.com/in/naga-vamsi-reddy-satti/'
						className='footer__social-link'
						target='_blank'
						rel='noopener noreferrer'>
						<i class='bx bxl-linkedin'></i>
					</a>
					<a
						href='https://github.com/vamsireddy99126'
						className='footer__social-link'
						target='_blank'
						rel='noopener noreferrer'>
						<i class='bx bxl-github'></i>
					</a>
				</div>

				<p className='footer__copy'>
					© {new Date().getFullYear()} Naga Vamsi Reddy Satti. All rights reserved
				</p>

			</div>
		</footer>
	);
};

export default Footer;
